import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { IDownloadFormsData, IVacanciesData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/custom/useToast";
import { useLoader } from "../context/LoaderContext";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";
import {
  fetchAcademicVacancies,
  fetchDownloadForms,
  fetchVacancies,
} from "../api/VacanciesApi";
import VacanciesSidebar from "../components/vacancies/VacanciesSidebar";
import VacanciesContent from "../components/vacancies/VacanciesContent";

const VacanciesPage = () => {
  const { setLoading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [adminVacancies, setAdminVacancies] = useState<IVacanciesData[]>([]);
  const [academicVacancies, setAcademicVacancies] = useState<IVacanciesData[]>(
    [],
  );
  const [downloadForms, setDownloadForms] = useState<IDownloadFormsData[]>([]);

  const vacancies = [...adminVacancies, ...academicVacancies];

  const [selectedVacancies, setSelectedVacancies] = useState<string>("");
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchVacancies(),
      fetchAcademicVacancies(),
      fetchDownloadForms(),
    ])
      .then(([vacanciesData, academicVacanciesData, downloadFormsData]) => {
        setAdminVacancies(vacanciesData);
        setAcademicVacancies(academicVacanciesData);
        setDownloadForms(downloadFormsData);
        setLoading(false);
        window.location.hash.replace("#", "") === "admin"
          ? setSelectedVacancies(vacanciesData[0]?.adv_code)
          : setSelectedVacancies(academicVacanciesData[0]?.adv_code);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
        setLoading(false);
      });
  }, [setLoading]);

  const selectedVacanciesDetails = vacancies.find(
    (item) => item.adv_code === selectedVacancies,
  );

  return (
    <>
      <Banner title="Academics" />
      <section id="introduction">
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_about td_style_1">
          <div className="container">
            {(mobile || tab) && (
              <div className="course_sidebar_toggle_wrapper td_mb_20">
                <h3 className="mb-0">Vacancy Position</h3>
                <button
                  className="course_sidebar_toggle mt-1"
                  onClick={() => setOpenSidebar(true)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  {/* <span></span>
                  <span></span>
                  <span></span> */}
                </button>
              </div>
            )}
            <div className="row td_gap_y_40 td_mb_40">
              <VacanciesSidebar
                adminVacancies={adminVacancies}
                academicVacancies={academicVacancies}
                selectedVacancies={selectedVacancies}
                setSelectedVacancies={setSelectedVacancies}
                openSidebar={openSidebar}
                setOpenSidebar={setOpenSidebar}
              />
              <VacanciesContent
                selectedVacanciesDetails={selectedVacanciesDetails}
                downloadFormsData={downloadForms}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VacanciesPage;
